import $ from "jquery";
import "slick-carousel";
import "pfkl-vcollapse/vcollapse/vcollapse.min.js";
import "./jvectormap/jquery-jvectormap.min.js";
import "./map/jquery-jvectormap-world-mill";
import "./worldmap.js";

// $(document).ready(function(){
jQuery(function () {
  // console.log('Ready', Math.floor(Date.now() / 1000));

  $(".spcific-accordion").vCollapse({
    any: true,
    onLoad: 0,
    speed: 300,
    easing: "ease-in-out",
    autoScroll: true,
  });

  $(".region-accordion").vCollapse({
    any: true,
    onLoad: "none",
    speed: 300,
    easing: "ease-in-out",
  });

  const hash = $(location).attr("hash");
  if (hash !== null) {
    var initialStoriesTab = 0;

    // switch(hash) {
    //   case '#learning-together':
    //     initialStoriesTab = 0;
    //     break;
    //   case '#working-together':
    //     initialStoriesTab = 1;
    //     break;
    //   case '#advancing-together':
    //     initialStoriesTab = 2;
    //     break;
    //   default:
    //     initialStoriesTab = 1;
    //     break;
    // }

    $(".tab-control").removeClass("active");
    $(".tab-control").each(function (index) {
      if (index === initialStoriesTab) {
        $(this).addClass("active");
      }
    });
  }

  function scrollToTop() {
    const c = document.documentElement.scrollTop || document.body.scrollTop;

    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, c - c / 8);
    }
  }

  var heroVideo = $("#hero-video");
  var heroVideoButton = $("#hero-video-control");

  // Play or pause hero video
  heroVideoButton.on("click", function () {
    if (heroVideo.get(0).paused) {
      heroVideo.get(0).play();
      heroVideoButton.attr(
        "src",
        "/themes/custom/idea/src/assets/button-video-pause.svg"
      );
    } else {
      heroVideo.get(0).pause();
      heroVideoButton.attr(
        "src",
        "/themes/custom/idea/src/assets/button-video-play.svg"
      );
    }
  });

  // Smooth scrolling to hash
  $("a[href*=\\#]:not([href=\\#])").on("click", function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );
        return false;
      }
    }
  });

  // Our impact articles slider
  $("#our-impact-articles-slider").slick({
    arrows: false,
    dots: false,
    fade: true,
    initialSlide: initialStoriesTab,
    swipe: false,
    touchMove: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          dots: false,
          fade: false,
          initialSlide: initialStoriesTab,
          swipe: true,
          touchMove: true,
          adaptiveHeight: true,
          asNavFor: $("#our-impact-articles-control-slider"),
        },
      },
    ],
  });

  $("#our-impact-category-text").slick({
    arrows: false,
    dots: false,
    fade: true,
    initialSlide: initialStoriesTab,
    swipe: false,
    touchMove: false,
  });

  // Events & News slider
  $("#event-new-slider .idea-slider").slick({
    rows: 3,
		dots: true,
		arrows: true,
		infinite: true,
    autoplay: false,
		speed: 300,
		slidesToShow: 2,
		slidesToScroll: 2,
    prevArrow: $('#event-new-slider .slick-prev'),
    nextArrow: $('#event-new-slider .slick-next'),
    appendDots: $("#event-new-slider .custom_dot"),
    dotsClass: 'custom_paging',
    customPaging: function (slider, i) {
      return (i + 1) + ' of ' + (Math.round(slider.slideCount / 2)).toFixed(0);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 3,
          slidesToShow: 1,
		      slidesToScroll: 1,
          customPaging: function (slider, i) {
            return (i + 1) + ' of ' + (slider.slideCount);
          },
        },
      },
    ],
  });

   // Conference Report slider
  $("#conference-new-slider .idea-slider").slick({
    rows: 3,
		dots: true,
		arrows: true,
		infinite: true,
    autoplay: false,
		speed: 300,
		slidesToShow: 2,
		slidesToScroll: 2,
    prevArrow: $('#conference-new-slider .slick-prev'),
    nextArrow: $('#conference-new-slider .slick-next'),
    appendDots: $("#conference-new-slider .custom_dot"),
    dotsClass: 'custom_paging',
    customPaging: function (slider, i) {
      return (i + 1) + ' of ' + (Math.round(slider.slideCount / 2)).toFixed(0);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 3,
          slidesToShow: 1,
		      slidesToScroll: 1,
          customPaging: function (slider, i) {
            return (i + 1) + ' of ' + (slider.slideCount);
          },
        },
      },
    ],
  });

  // Our impact articles slider on afterChange update .slider-control
  $("#our-impact-articles-slider").on("afterChange", function (e, s, c) {
    $(".slider-control").removeClass("active");
    $('.slider-control[data-slide="' + c + '"]').addClass("active");
  });

  // Slider control, on click make #our-impact-articles-slider go to selected slide
  $(".slider-control").on("click", function () {
    var elm = $(this);
    const target = $(elm.data("target"));
    const targetMobile = $(elm.data("target-mobile"));
    const slide = elm.data("slide");

    $(".slider-control").removeClass("active");
    elm.addClass("active");
    target.slick("slickGoTo", parseInt(slide));
    targetMobile.slick("slickGoTo", parseInt(slide));
  });

  // Our impact articles slider control (mobile)
  $("#our-impact-articles-control-slider").slick({
    arrows: false,
    dots: false,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    variableWidth: true,
    asNavFor: $("#our-impact-articles-slider"),
    focusOnSelect: true,
    initialSlide: 1,
  });
  // Sliders END
  /////////////////////////////////////////////////////////////////////////////

  let cpTimeout;

  $(window).on("resize", function () {
    if ($("#country-panel").hasClass("active")) {
      window.clearTimeout(cpTimeout);

      cpTimeout = setTimeout(() => {
        console.log("resizing... panel");
        resizeCountryPanel();
      }, 100);
    }

    // resizeMap();
    // resizeGlobe();
  });
});
// Document.ready END
///////////////////////////////////////////////////////////////////////////////

// Youtube API ////////////////////////////////////////////////////////////////
var tag = document.createElement("script");

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;

$(".button-play-youtube-video").on("click", function () {
  var elm = $(this);
  const target = elm.data("target");
  const videoId = elm.data("video-id");

  elm.parent().addClass("playing");

  player = new YT.Player(target, {
    height: "100%",
    width: "100%",
    videoId: videoId,
    playerVars: {
      showinfo: 0,
      modestbranding: 0,
      title: "",
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: function (event) {
        if (event.data == YT.PlayerState.ENDED) {
          player.destroy();
          elm.parent().removeClass("playing");
        }
      },
    },
  });
});

function onPlayerReady(event) {
  event.target.playVideo();
}

// policy brief dropdown
$(".policyBriefDropdown").on("click", function (e) {
  e.preventDefault();
  if ($(this).hasClass("policyBriefDropdownOpen")) {
    $(this).removeClass("policyBriefDropdownOpen");
    $(this).find(".options").addClass("hidden");
  } else {
    $(this).find(".options").removeClass("hidden");
    $(this).addClass("policyBriefDropdownOpen");
  }
});

// stop closing dropdown when child element is clicked
$(".policyBriefDropdown .options").on("click", function (e) {
  e.stopPropagation();
});

// home jump to section
$(".jump-to a.group").on("click", function (e) {
  e.stopPropagation();
  let updateText = $(this).text();
  $(".jump-to .icon-chevron-down").html(updateText);
  $(".jump-to .icon-chevron-down").trigger('click');
});
